/* unplugin-vue-components disabled */import { render } from "./ModalLoader.vue?vue&type=template&id=61a93912&scoped=true"
const script = {}

import "./ModalLoader.vue?vue&type=style&index=0&id=61a93912&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a93912"]])

export default __exports__